import React from "react";
import { Link } from "react-router-dom";

import { Section } from "@jsluna/section";

import {
  Notification,
  NotificationStatuses,
} from "@jsainsburyplc/id-ui-common";

import { getInitiateRegistrationLink } from "utils/urls";

import AlreadyHaveAnAccount from "components/AlreadyHaveAnAccount";

const TokenExpiredNotification = () => (
  <>
    <div className="c-hero c-hero--center">
      <h1>Registration link expired</h1>
    </div>

    <Section>
      <Notification type={NotificationStatuses.WARNING_TYPE}>
        This link has expired and is no longer valid. To get a new link please{" "}
        <Link
          className="ln-c-link ln-c-link--alpha"
          to={getInitiateRegistrationLink()}
        >
          register again
        </Link>
        .
      </Notification>
    </Section>

    <AlreadyHaveAnAccount />
  </>
);

export default TokenExpiredNotification;
